import { configureStore } from "@reduxjs/toolkit";
import globalStateReducer from "./globalStateSlice";

export default configureStore({
  reducer: {
    globalState: globalStateReducer
  }
});
